module.exports = __webpack_public_path__ + "static/media/volume.e35f96d8.svg";